export const makeIntegerFromString = (str: string): number => {
  const num = Number.parseInt(str, 10)
  return Number.isInteger(num) ? num : 0
}
